<template>
  <div class="pages">
    <div class="container">
      <div class="block-user-info">
        <!-- <div class="block-user">
          <div class="block-user-avatar">
            <img :src="avatarUrl" draggable="false" v-if="avatarUrl" />
          </div>
          <div class="block-user-name">{{ username }}</div>
        </div> -->
        <div class="block-refresh" @click="handleRefreshClick">
          <img
            :class="[isRefreshing && 'block-refresh-loading']"
            :src="require('@/assets/images/moonpoints/icon_refresh@2x.png')"
          />
        </div>
      </div>
      <div class="block-daily-points">
        <div class="daily-points-title">
          {{
            localesPackage?.["task_title_daily"]?.[localesEnv] ||
            "DAILY TO THE MOON RING"
          }}
        </div>
        <div class="block-refresh-time">
          {{ refreshTimeTips }}
        </div>
        <div class="daily-points-row">
          <div class="daily-points-content">
            <div class="text-title">
              {{
                localesPackage?.["task_title_today_mpt"]?.[localesEnv] ||
                "Today MPT:"
              }}
            </div>
            <div class="text-points">
              {{ dailyPoints ? dailyPoints.toLocaleString("en") : 0 }}
              <span class="text-points-sub"
                >/{{
                  dailyPointsTotal ? dailyPointsTotal.toLocaleString("en") : 0
                }}</span
              >
            </div>
          </div>
          <div class="block-total-points">
            <div class="block-total-points-text">
              {{ `${totalPoints ? totalPoints.toLocaleString("en") : 0}` }}
              <span class="block-total-points-text-sub">{{ " " }}MPT</span>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="block-daily-points-list">
          <div
            class="block-daily-points-item"
            v-for="(item, index) in missionsDisplayList"
            :key="index"
          >
            <MoonPointsItem
              :data="item"
              :index="(index % 5) + 1"
              :isRequestLoading="isRequestLoading"
              :RequestLoadingId="RequestLoadingId"
              @onClaim="handleClaimClick"
              @onUnable="handleUnableClick"
            />
          </div>
        </div>
        <div class="main-empty"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  onMounted,
  ref,
  getCurrentInstance,
  onBeforeMount,
  onUpdated,
} from "vue";
import { mapState } from "vuex";
import MoonPointsItem from "@/views/H5/MoonPoints/components/MoonPointsItem";
import { getMissions, getMoonPoint, postMissions } from "@/api/mission.js";
import { postLogin, postCaptcha, getUserProfile } from "@/api/login.js";
import missionsLocal from "@/views/H5/MoonPoints/constants/missionsLocal.json";
import appBridging from "@/utils/appBridging.js";
import { TOAST_TYPE } from "@/components/Toast/index.vue";
import { getMoonRingTask } from "@/api/language.js";
import store from "@/store";
import Masonry from "masonry-layout";
import { timezoneMap } from "@/views/H5/MoonPoints/constants/timezoneMap.js";
import moment from "moment-timezone";

export default {
  components: {
    MoonPointsItem,
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      resume: (state) => state.global.resume,
      statusBarHeight: (state) => state.global.statusBarHeight,
      appUserInfo: (state) => state.global.appUserInfo,
      userMeasureHeartRateCount: (state) =>
        state.global.userMeasureHeartRateCount,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    init: {
      handler(value) {
        if (!value) return;
        // this.handlePageInit();
      },
      immediate: true,
      deep: true,
    },
    appUserInfo: {
      async handler(value) {
        // if (!value) return;
        this.handleUserInfoInit(value);
      },
      immediate: true,
      deep: true,
    },
    resume: {
      handler(value) {
        if (!value) return;
        this.handlePageRefresh();
      },
      immediate: true,
      deep: true,
    },
    userMeasureHeartRateCount: {
      handler(value) {
        this.userMeasureHeartRateCountLocal = value;

        this.handleMissionLocalCheck();
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        console.log("languageEnv: ", value);
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        console.log("languagePackage: ", value);
        if (value) {
          this.localesPackage = value;
          if (value?.version > 0) {
            this.handlePageRefresh();
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  props: {},
  setup(props) {
    const { proxy } = getCurrentInstance();

    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const avatarUrl = ref("");
    const username = ref("");
    const totalPoints = ref(0);
    const dailyPoints = ref(0);
    const dailyPointsTotal = ref(0);
    const missionsDisplayList = ref([]);
    const missionsList = ref([]);

    const isRequestLoading = ref(false);
    const RequestLoadingId = ref("");

    const userMeasureHeartRateCountLocal = ref(null);

    const isRefreshing = ref(false);

    const refreshTimeValue = ref("0:00 UTC+8:00");
    const refreshTimeTips = ref("");

    onBeforeMount(async () => {
      appBridging.getSettingLaungage();

      const res = await getMoonRingTask();
      console.log("languagePackage: ", res);
      store.dispatch("global/setLanguagePackage", res); // 存到stroe
    });

    onUpdated(() => {
      const masonry = new Masonry(".block-daily-points-list", {
        itemSelector: ".block-daily-points-item",
        gutter: 11,
        horizontalOrder: true,
        resize: true,
      });
    });

    onMounted(() => {});

    const handlePageInit = async () => {
      console.log("pageInit");

      appBridging.getUserInfo();

      appBridging.getMeasureHeartRateCount();

      handleInitUserTimezone();

      handleScoreInfoInit();

      await handleMissionInfoInit();
    };

    const handlePageRefresh = async () => {
      console.log("pageRefresh");

      // 模拟登录获取token
      // await postCaptcha({
      //   email: "625251529@qq.com",
      //   iv: "xsextkoubapsqyea",
      // });

      // await postLogin({
      //   token: '123456',
      //   email: "625251529@qq.com",
      // });

      if (isRefreshing.value) {
        return;
      }

      isRefreshing.value = true;

      appBridging.getSettingLaungage();

      appBridging.getUserInfo();

      appBridging.getMeasureHeartRateCount();

      handleInitUserTimezone();

      handleScoreInfoInit();

      await handleMissionInfoInit();
      isRefreshing.value = false;
    };

    const handleScoreInfoInit = async () => {
      try {
        const res_score = await getMoonPoint();
        console.log("score", res_score);
        const today_score = res_score?.data?.today_score || 0;
        const total_score = res_score?.data?.total_score || 0;
        totalPoints.value = total_score;
        dailyPoints.value = today_score;
      } catch (error) {
        console.log("error", error);
      }
    };

    const handleMissionInfoInit = async () => {
      try {
        const res = await getMissions();
        const missions = res?.data || [];
        missionsList.value = missions;
        console.log("missions", missions);

        handleMissionsParse();
      } catch (error) {
        console.log("error", error);
      }
    };

    const handleUserInfoInit = async (value) => {
      console.log("appUserInfo", value);
      const _username = value?.username || "";
      const _avatar_url = value?.avatar_url || "";

      avatarUrl.value = _avatar_url;
      username.value = _username;
    };

    const handleInitUserTimezone = async () => {
      const res = await getUserProfile();
      const value = res?.data || null;

      // 时区展示
      const _timezone = value?.timezone || "Europe/London";

      const utcOffset = moment.tz(_timezone).format("Z");

      refreshTimeValue.value = `0:00 UTC${utcOffset}`;

      const _refresh_time_string =
        localesPackage.value?.["task_refresh_time"]?.[localesEnv.value] ||
        "Refresh At ${a}(Local Time Zone)";
      refreshTimeTips.value = _refresh_time_string.replace(
        "${a}",
        refreshTimeValue.value
      );

      console.log(
        "handleInitUserTimezone",
        localesPackage.value?.["task_refresh_time"]?.[localesEnv.value],
        _refresh_time_string,
        refreshTimeTips.value
      );
    };

    const handleMissionsParse = () => {
      const _missions = [];
      for (const i in missionsList.value) {
        const item = missionsList.value[i];
        const item_name = item?.name || "";

        const _item = missionsLocal.find((item) => {
          return item.name === item_name;
        });

        if (_item) {
          _missions.push({ ...item, ..._item });
        } else {
          _missions.push({ ...item });
        }
      }

      const _missions_local = missionsLocal.filter((item) => {
        return item?.isLocal;
      });

      console.log("_missions", _missions, _missions_local);
      missionsDisplayList.value = [..._missions, ..._missions_local];

      handleMissionI18n();

      handleMissionLocalCheck();

      let dailyMoonPoint = 0;
      for (const i in missionsDisplayList.value) {
        const item = missionsDisplayList.value[i];
        const mission_reward = item?.mission_reward || null;
        const key = mission_reward?.key;
        const is_prop = mission_reward?.is_prop;
        const amount = mission_reward?.amount || "0";
        const isUnable = item?.isUnable || false;

        if (!is_prop && key == "mpt" && !isUnable) {
          dailyMoonPoint += Number(amount);
        }
      }
      dailyPointsTotal.value = dailyMoonPoint;
    };

    const handleMissionLocalCheck = () => {
      for (const i in missionsDisplayList.value) {
        const item = missionsDisplayList.value[i];
        const is_check_done = item?.is_check_done;
        if (!is_check_done) {
          const conditions = item?.conditions || [];
          const conditions_status = [];
          for (const j in conditions) {
            const condition = conditions[j];
            const _key = condition?.key;
            const _isLocalFinish = handleConditionCheck(_key, condition);
            conditions_status.push(_isLocalFinish);
          }
          const _status = conditions_status.every((item) => {
            return item;
          });
          item["_isLocalFinish"] = _status;
        }
      }
    };

    const handleConditionCheck = (condition_key, condition) => {
      console.log(
        "mission check app data",
        userMeasureHeartRateCountLocal.value
      );

      let status = false;
      const userMeasureHeartRateCount =
        userMeasureHeartRateCountLocal.value?.count || 0;

      switch (condition_key) {
        case "check_heart_rate":
          status = userMeasureHeartRateCount > 0;
          break;
      }
      return status;
    };

    const handleMissionI18n = () => {
      for (const i in missionsDisplayList.value) {
        const item = missionsDisplayList.value[i];
        const i18n_key_name = item?.i18n_key_name;
        const i18n_key_desc = item?.i18n_key_desc;

        const i18n_name =
          localesPackage.value?.[i18n_key_name]?.[localesEnv.value] || "";
        const i18n_desc =
          localesPackage.value?.[i18n_key_desc]?.[localesEnv.value] || "";

        item["i18n_name"] = i18n_name;
        item["i18n_desc"] = i18n_desc;
      }
    };

    const handleClaimClick = async (item) => {
      console.log("handleClaimClick", item);

      const id = item?.id || "";
      if (!id) return;

      if (isRequestLoading.value) return;

      try {
        isRequestLoading.value = true;
        RequestLoadingId.value = id;

        const res = await postMissions({
          id,
        });

        await handlePageRefresh();

        proxy.$toast.show({
          msg:
            localesPackage.value?.["task_tips_text_success"]?.[
              localesEnv.value
            ] || `Claim Success!`,
          type: TOAST_TYPE.SUCCESS,
        });
      } catch (error) {
        proxy.$toast.show({
          msg:
            localesPackage.value?.["task_tips_text_error"]?.[
              localesEnv.value
            ] || `Claim failed, please try again later!`,
          type: TOAST_TYPE.ERROR,
        });
      } finally {
        isRequestLoading.value = false;
        RequestLoadingId.value = "";
      }
    };

    const handleUnableClick = (item) => {
      console.log("handleUnableClick", item);

      const _title_key = item?.i18n_key_name;
      const _title_name = item?.name;

      const _desc_key = item?.i18n_key_desc;
      const _desc_name = item?.description_local;

      const _value = item?.mission_reward?.amount;

      const _title =
        localesPackage.value?.[_title_key]?.[localesEnv.value] || _title_name;
      const _content =
        localesPackage.value?.[_desc_key]?.[localesEnv.value] || _desc_name;
      const _btn_title =
        localesPackage.value?.["task_list_tips_btn_ok"]?.[localesEnv.value] ||
        "OK";

      console.log("handleUnableClick", _title, _content, _value);

      appBridging.showInfoPopup({
        title: _title,
        content: _content,
        value: _value,
        buttonTitle: _btn_title,
      });
    };

    const handleRefreshClick = async () => {
      if (isRefreshing.value) return;

      await handlePageRefresh();
    };

    return {
      avatarUrl,
      username,
      totalPoints,
      dailyPoints,
      dailyPointsTotal,
      missionsDisplayList,
      isRequestLoading,
      RequestLoadingId,
      handlePageInit,
      handleUserInfoInit,
      handlePageRefresh,
      handleClaimClick,
      handleUnableClick,
      userMeasureHeartRateCountLocal,
      handleMissionLocalCheck,
      isRefreshing,
      handleRefreshClick,
      localesPackage,
      localesEnv,
      refreshTimeValue,
      refreshTimeTips,
    };
  },
};
</script>

<style lang="less" scoped>
.pages {
  width: 100dvw;
  height: 100dvh;
  overflow: hidden;
  background: #180538;
  // background-image: url("~@/assets/images/moonpoints/bg@2x.png");
  // background-size: cover;
  display: flex;
  flex-direction: column;
  font-family: "Inter";

  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding: 0px 16px;
    width: 100%;
    box-sizing: border-box;

    .block-user-info {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      margin-top: 54px;
      padding: 0px 16px;
      box-sizing: border-box;

      .block-user {
        min-width: 0;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;

        &-avatar {
          flex-shrink: 0;
          width: 25px;
          height: 25px;
          border-radius: 50%;
          background-color: #f8f8f8;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            // border-radius: 50%;
          }
        }

        &-name {
          font-size: 22px;
          line-height: 26.63px;
          color: #ffffff;
          margin-left: 8px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    .block-daily-points {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 0px 20px;
      box-sizing: border-box;

      .daily-points {
        &-row {
          width: 100%;
          display: flex;
          flex-direction: row;
          align-items: flex-end;
          justify-content: space-between;
          margin-top: 16px;
        }

        &-title {
          color: #ffffff;
          font-family: "Inter";
          font-size: 26px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          text-transform: capitalize;
          text-align: left;
        }

        &-content {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;

          .text {
            &-title {
              color: #ffffff;
              font-family: "Inter";
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
              margin-bottom: 4px;
            }

            &-points {
              color: #ffffff;
              text-align: right;
              font-family: "Inter";
              font-size: 22px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;

              &-sub {
                font-weight: 300;
              }
            }
          }
        }
      }

      .block-total-points {
        flex-shrink: 0px;
        height: 38px;
        padding: 0 16px;
        border-radius: 24px;
        background: #3c2e75;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &-text {
          color: #ffffff;
          font-family: "Inter";
          font-size: 18px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;

          &-sub {
            color: #ffffff;
            font-family: "Inter";
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            text-transform: uppercase;
            margin-left: 4px;
          }
        }
      }
    }

    .block-refresh-time {
      color: #ffffff80;
      font-family: "Inter";
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      text-transform: capitalize;
      margin-top: 1px;
    }

    .block-refresh {
      width: 24px;
      height: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // margin-left: 4px;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }

      &-loading {
        animation: rotate 1s linear infinite;
      }

      @keyframes rotate {
        from {
          transform-origin: center center;
          transform: rotate(0deg);
        }
        to {
          transform-origin: center center;
          transform: rotate(360deg);
        }
      }
    }

    .main {
      max-height: calc(100dvh - 200px);
      overflow: hidden;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      margin-top: 16px;

      &-empty {
        height: 40px;
        width: 100%;
      }
    }

    .block-daily-points-list {
      flex: 1;
      width: 100%;
      padding: 0px 16px;
      box-sizing: border-box;
      column-count: 2;
      column-width: 166px;
      column-gap: 11px;
      margin-bottom: 10px;

      .block-daily-points-item {
        display: inline-block;
        width: 166px;
        break-inside: avoid;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
